import { Component, ElementRef, Input } from '@angular/core';

/**
 * Arrow button for long view pages. Put <app-page-jump-arrows position="top"> as the first line of
 * a template and <app-page-jump-arrows position="bottom"> as the last line (same parent): the top
 * arrow scrolls down to the bottom one and the bottom arrow scrolls up to the top one.
 */
@Component({
  selector: 'app-page-jump-arrows',
  template: `
    <div class="text-right">
      <button *ngIf="position === 'top'" nz-button nzType="primary" nzShape="circle" title="Go to bottom" (click)="jump()">
        <i nz-icon nzType="arrow-down" nzTheme="outline" class="bounce-down"></i>
      </button>
      <button *ngIf="position === 'bottom'" nz-button nzType="primary" nzShape="circle" title="Go to top" (click)="jump()">
        <i nz-icon nzType="arrow-up" nzTheme="outline" class="bounce-up"></i>
      </button>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    /* the icon keeps nudging in the direction it scrolls to */
    .bounce-down {
      display: inline-block;
      animation: bounce-down 1.2s ease-in-out infinite;
    }

    .bounce-up {
      display: inline-block;
      animation: bounce-up 1.2s ease-in-out infinite;
    }

    @keyframes bounce-down {
      0%, 100% { transform: translateY(-2px); }
      50% { transform: translateY(4px); }
    }

    @keyframes bounce-up {
      0%, 100% { transform: translateY(2px); }
      50% { transform: translateY(-4px); }
    }

    @media (prefers-reduced-motion: reduce) {
      .bounce-down,
      .bounce-up {
        animation: none;
      }
    }
  `]
})
export class PageJumpArrowsComponent {

  @Input() position: 'top' | 'bottom' = 'top';

  constructor(private el: ElementRef<HTMLElement>) {}

  jump(): void {
    const target = this.position === 'top' ? 'bottom' : 'top';
    const other = this.el.nativeElement.parentElement?.querySelector(`:scope > app-page-jump-arrows[position="${target}"]`);
    other?.scrollIntoView({ behavior: 'smooth' });
  }
}
